"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("../../theme");

var _antd = require("antd");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MenuWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  .ant-menu-item,\n  .menu-item {\n    color: ", ";\n    height: 36px;\n    line-height: 36px;\n    padding: 0 12px;\n    font-size: ", ";\n    &:active,\n    &:hover {\n      background: ", ";\n      color: ", ";\n    }\n    &.ant-menu-item-selected {\n      background: ", ";\n      color: ", ";\n      &::after {\n        border-right: 0;\n      }\n    }\n    &::after {\n      border-right: 0;\n    }\n  }\n  .ant-menu-submenu-title {\n    color: ", ";\n    font-size: ", ";\n    &:hover {\n      color: ", ";\n      background: ", ";\n      .ant-menu-submenu-arrow {\n        color: ", ";\n      }\n    }\n  }\n  .ant-menu-item-group-title {\n    color: ", ";\n    padding: 0 16px;\n    font-size: ", ";\n  }\n"])), function (props) {
  return props.width;
}, _theme.theme.colors.black_secondary, _theme.theme.font_size.size_l, _theme.theme.colors.light_grey, _theme.theme.colors.black_secondary, _theme.theme.colors.light_grey, _theme.theme.colors.black_secondary, _theme.theme.colors.black_secondary, _theme.theme.font_size.size_l, _theme.theme.colors.black_secondary, _theme.theme.colors.transparent, _theme.theme.colors.black_secondary, _theme.theme.colors.grey_tertiary, _theme.theme.font_size.size_l);

var getItem = function getItem(data) {
  return /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
    key: data.key,
    className: data.className
  }, /*#__PURE__*/_react.default.createElement("span", null, data.icon), data.icon ? " " + data.title : data.title);
};

var getSubMenu = function getSubMenu(child) {
  var subMenu = [];
  child.items.map(function (item) {
    subMenu.push(getItem(item));
  });
  return subMenu;
};

var getMenuItem = function getMenuItem(props) {
  var list = [];
  props.items.length && props.items.map(function (child) {
    if ("items" in child) {
      if (props.type === "itemGroup") {
        list.push( /*#__PURE__*/_react.default.createElement(_antd.Menu.ItemGroup, {
          title: child.title,
          key: child.key
        }, getSubMenu(child)));
      } else if (props.type === "submenu") {
        list.push( /*#__PURE__*/_react.default.createElement(_antd.Menu.SubMenu, {
          title: child.title,
          key: child.key
        }, getSubMenu(child)));
      } else {
        list.push(getItem(child));
      }
    } else {
      list.push(getItem(child));
    }
  });
  return list;
};

function MenuComponent(props) {
  var rest = _extends({}, props);

  return /*#__PURE__*/_react.default.createElement(MenuWrapper, {
    width: props.width
  }, /*#__PURE__*/_react.default.createElement(_antd.Menu, _extends({
    className: props.className,
    multiple: props.multiple,
    onClick: props.onClick ? function (item) {
      return props.onClick(item);
    } : null,
    mode: props.mode
  }, rest), getMenuItem(props)));
}

var _default = MenuComponent;
exports.default = _default;